<div class="page-layout simple fullwidth">
    <!-- HEADER -->

    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="row" fxLayoutAlign="start center">
            <button
                mat-icon-button
                class="mr-0 mr-sm-16"
                [routerLink]="'/cotizaciones'"
            >
                <mat-icon>arrow_back</mat-icon>
            </button>

            <div
                fxLayout="column"
                fxLayoutAlign="start start"
                [@animate]="{
                    value: '*',
                    params: { delay: '100ms', x: '-25px' }
                }"
            >
                <div class="h2">
                    {{ "QUOTATION.QUOTATION" | translate | uppercase }}
                    {{ idCotizacion }}
                </div>

                <div class="subtitle secondary-text">
                    <span *ngIf="cotizacion && cotizacion.fechaVigencia">
                        Vence el {{ cotizacion.fechaVigencia }}</span
                    >
                </div>
            </div>
        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->

    <div class="content p-24">
        <app-servicios-cotizacion
            (solicitarServicio)="openDialogSolicitarServicio($event)"
            (rechazarServicio)="openDialogRechazarServicio($event)"
            (verDetalleServicioEvent)="openDialogDetalleServicio($event)"
            (cotizarServicio)="cotizarServicio($event)"
            (invitar)="invitarACotizar($event)"
            (refrescarDatos)="refrescarDatos($event)"

        ></app-servicios-cotizacion>
        
    </div>
    <!-- / CONTENT -->
</div>
